import { CLIENT_ID_HEADER } from '@payaca/shared-isomorphic/constants/clientId';

import { TOKEN_KEY } from '@/api/index';
import { refreshAuthTokens } from '@/api/refreshAuthTokens';

export const apiFetch = async (path: string, requestInit?: RequestInit) => {
  const doFetch = () => {
    const token = localStorage.getItem(TOKEN_KEY);

    const headers = new Headers({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      [CLIENT_ID_HEADER]: 'webapp-provider',
    });

    for (const [key, value] of new Headers(requestInit?.headers)) {
      headers.set(key, value);
    }

    return fetch(`${import.meta.env.VITE_API_HOST}${path}`, {
      ...requestInit,
      headers,
    });
  };

  const response = await doFetch();
  if (response.status !== 401) {
    return response;
  }

  const { wasRefreshed } = await refreshAuthTokens();
  return wasRefreshed ? doFetch() : response;
};
